import * as React from "react";
const SvgBrowserGraph = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 2.813v18.375H22.13V2.811H12ZM3.38 4.31H20.62v2.246H3.38V5.434Zm0 3.753H20.62V13.123h-6.273l-.438.873c-.24.48-.438.875-.441.875-.003 0-.51-1.212-1.127-2.693s-1.126-2.69-1.13-2.688c-.003.002-.549.82-1.214 1.819l-1.209 1.814H3.38v-2.53Zm7.53 4.584.02.05c.012.026.558 1.336 1.216 2.913.657 1.578 1.196 2.87 1.199 2.87.002 0 .437-.868.967-1.926l.962-1.924h5.348v5.058H3.38V14.63h6.209l.66-.99z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgBrowserGraph;
